var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHumiditySensor(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 37,
    viewBox: "0 0 30 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15 35.4167C22.5185 35.4167 28.75 29.8012 28.75 22.7135C28.75 18.286 26.4895 13.8053 23.9338 10.1332C21.3617 6.43534 18.3935 3.42317 16.793 1.89967C16.3107 1.43713 15.6683 1.17889 15 1.17889C14.3317 1.17889 13.6893 1.43713 13.207 1.89967C11.6065 3.42134 8.63833 6.43534 6.06617 10.1332C3.5105 13.8053 1.25 18.286 1.25 22.7135C1.25 29.8012 7.4815 35.4167 15 35.4167Z",
    stroke: "#111111",
    strokeWidth: 1.83333
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15 29C13.0551 29 11.1898 28.2274 9.81455 26.8521C8.43928 25.4769 7.66666 23.6116 7.66666 21.6667",
    stroke: "#111111",
    strokeWidth: 1.83333,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHumiditySensor);
export default __webpack_public_path__ + "static/media/humidity-sensor.92092c0b95fc36f8691e44c01b0e3c11.svg";
export { ForwardRef as ReactComponent };